/*
  Confezione regalo — scelta in scheda prodotto (Emme4Home)

  Se il cliente spunta la confezione, intercetta l'invio del form prodotto
  PRIMA di main-product.js (il suo listener sta su <main-product>, quindi
  basta fermare la propagazione dal form) e manda un solo /cart/add.js con
  due righe: l'articolo e la sua confezione, legata con _per.
  Poi rende il drawer con le stesse API del tema, cosi il comportamento
  dopo l'aggiunta resta identico a quello standard.

  Se la casella non e spuntata non fa nulla: il tema lavora come sempre.
*/
(function () {
  function cfg(type) {
    if (typeof fetchConfig === 'function') return fetchConfig(type || 'json');
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/' + (type || 'json') }
    };
  }

  class GiftWrapProduct extends HTMLElement {
    constructor() {
      super();
      this.inCorso = false;
      this.onSubmit = this.onSubmit.bind(this);
      this.onChange = this.onChange.bind(this);
      this.onClick = this.onClick.bind(this);
    }

    connectedCallback() {
      this.mainProduct = this.closest('main-product');

      const form = this.closest('form');
      if (form && form !== this.formLegata) {
        this.formLegata = form;
        form.addEventListener('submit', this.onSubmit);
      }

      if (!this.ascolti) {
        this.ascolti = true;
        this.addEventListener('change', this.onChange);
        this.addEventListener('click', this.onClick);
      }
    }

    get toggle() {
      return this.querySelector('.cgrp__toggle');
    }

    get varianteConfezione() {
      const scelto = this.querySelector('.cgrp__style.is-selected');
      if (scelto && scelto.dataset.stile) return scelto.dataset.stile;
      return this.toggle ? this.toggle.dataset.addId : null;
    }

    /*
      main-product.js ricarica la scheda a ogni "change" che gli arriva:
      i nostri controlli non devono farlo scattare.
    */
    onChange(event) {
      event.stopPropagation();
      if (!event.target.classList.contains('cgrp__toggle')) return;
      const box = this.querySelector('.cgrp__styles');
      if (box) box.hidden = !event.target.checked;
    }

    onClick(event) {
      const btn = event.target.closest('.cgrp__style');
      if (!btn || btn.tagName !== 'BUTTON') return;
      this.querySelectorAll('.cgrp__style').forEach(function (el) {
        el.classList.remove('is-selected');
        if (el.tagName === 'BUTTON') el.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('is-selected');
      btn.setAttribute('aria-pressed', 'true');
    }

    onSubmit(event) {
      if (!this.toggle || !this.toggle.checked) return;
      if (this.inCorso) return;
      if (!this.varianteConfezione) return;

      event.preventDefault();
      event.stopPropagation();
      this.invia();
    }

    invia() {
      const self = this;
      const form = this.formLegata;
      const mp = this.mainProduct;
      const drawer = document.querySelector('cart-drawer');
      const bottone = form.elements['add'];

      const dati = new FormData(form);
      const articolo = {
        id: Number(dati.get('id')),
        quantity: Number(dati.get('quantity') || 1)
      };
      if (dati.get('selling_plan')) articolo.selling_plan = Number(dati.get('selling_plan'));

      const proprieta = {};
      let haProprieta = false;
      dati.forEach(function (valore, chiave) {
        const m = /^properties\[(.+)\]$/.exec(chiave);
        if (m && valore) {
          proprieta[m[1]] = valore;
          haProprieta = true;
        }
      });
      if (haProprieta) articolo.properties = proprieta;

      const confezione = {
        id: Number(this.varianteConfezione),
        quantity: 1,
        properties: { _per: articolo.id }
      };

      // Shopify inverte l'ordine delle righe in un'aggiunta multipla:
      // mandando prima la confezione, in carrello l'articolo resta sopra.
      const corpo = { items: [confezione, articolo], sections_url: window.location.pathname };
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        corpo.sections = drawer.getSectionsToRender().map(function (s) { return s.section; });
      }

      this.inCorso = true;
      if (bottone) bottone.classList.add('disabled');

      fetch(routes.cart_add_url, Object.assign({}, cfg(), { body: JSON.stringify(corpo) }))
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) {
            if (mp && typeof mp.handleErrorMessage === 'function') {
              mp.handleErrorMessage(res.description || res.message);
            }
            return;
          }

          const tipo = mp ? mp.dataset.cartType : null;
          if (tipo === 'page' || (window.Shopify && window.Shopify.template === 'cart') || !drawer) {
            window.location.reload();
            return;
          }

          drawer.renderContents(res);
          const quickview = document.querySelector('#Product-Quickview-Modal[open]');
          if (quickview && typeof quickview.hide === 'function') quickview.hide();
        })
        .catch(function (e) {
          console.error('[confezione-regalo] scheda prodotto', e);
          if (mp && typeof mp.handleErrorMessage === 'function') {
            mp.handleErrorMessage('Non riesco ad aggiungere al carrello. Riprova tra un attimo.');
          }
        })
        .finally(function () {
          self.inCorso = false;
          if (bottone) bottone.classList.remove('disabled');
        });
    }
  }

  if (!customElements.get('gift-wrap-product')) {
    customElements.define('gift-wrap-product', GiftWrapProduct);
  }
})();
